
import { Component, OnDestroy, OnInit } from '@angular/core';
import { KeyValEntry } from '@shared/KeyValStore';
import { KeyValService } from 'src/app/shared/services/key-val.service';

@Component({
    selector: 'app-bot-debug-keyval',
    imports: [],
    templateUrl: './bot-debug-keyval.component.html',
    styleUrl: './bot-debug-keyval.component.scss'
})
export class BotDebugKeyvalComponent implements OnInit, OnDestroy {
    public eventManagerEntries: KeyValEntry[] = [];
    public stageManagerEntries: KeyValEntry[] = [];
    private refreshInterval: ReturnType<typeof setInterval> | null = null;

    constructor(private keyValService: KeyValService) { }

    public ngOnInit(): void {
        void this.refresh();
        this.refreshInterval = setInterval(() => void this.refresh(), 2000);

        this.keyValService.onKeyValUpdate.subscribe(() => void this.refresh());
        this.keyValService.onKeyValDelete.subscribe(() => void this.refresh());
    }

    public ngOnDestroy(): void {
        if (this.refreshInterval) {
            clearInterval(this.refreshInterval);
        }
    }

    public async refresh(): Promise<void> {
        await this.keyValService.waitForInit();
        this.eventManagerEntries = await this.keyValService.getKeyValByType('EVENT-MANAGER');
        this.stageManagerEntries = await this.keyValService.getKeyValByType('STAGE_MANAGER');
    }
}
